import { compose }      from 'redux';
import store            from '../config/store';

// actionSanizer'lar fırlatılan action'ların payload verisinde 
// yer alan bilgileri kullanarak, action'ları belirli bir patternde
// redux devtool'a gönderir. Böylece hangi modülün hangi olay ya da durum
// sonunda hangi TYPE creator'ı fırlattığı kolaylıkla izlenebilir.

const actionSanitizer = (action) => {
    let module = action.owner || 'Global';
    let actionType = action.isApi === true 
                        ? 'Api' 
                        : 'Event';
    return { ...action , type: module + '/' + actionType + '/' + action.type}
}; 

const composeEnhancers = () => {
  let config = store.profiles.client;
  return typeof window !== 'undefined'
                ? config.devTool.environment.includes(store.appEnvironment)
                    && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ 
                    && config.devTool.initDevTool
                ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
						name: config.devTool.instanceName,
						actionsBlacklist: config.devTool.actionBlackList,
						actionSanitizer
                  })
                  	: compose
                	: compose;
}

export default composeEnhancers();